<template>
  <div>
    <popper
      trigger="hover"
      :options="{
        placement: 'top',
        modifiers: { offset: { offset: '0,10px' } },
      }"
    >
      <div class="popper">
        {{ competence.name }}
      </div>

      <div class="icon-wrapper" slot="reference">
        <i v-if="competence.devicon" :class="compileCompetenceClass(competence.devicon)"></i>
        <img v-else src="/img/comstream.svg" alt="shark" />
        <span class="competence-name text-nowrap">{{ competence.name | truncate(10) }}</span>
      </div>
    </popper>
  </div>
</template>

<script>
export default {
  props: {
    competence: {
      type: Object,
    },
  },
  methods: {
    compileCompetenceClass(competence) {
      if (competence === 'dot-net') {
        return 'devicon-dot-net-plain colored';
      } else {
        if (competence != null) competence = competence.split(' ');
        return `${competence} colored`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #6c6c6c;
  width: 16px !important;
  height: auto;
}

i {
  display: block;
  margin-top: 10px;
  line-height: 0.8;
  font-size: 1.3rem !important;
}

.competence-name {
  font-size: 10px;
  margin: 0;
}

img {
  width: 25px;
  height: 25px;
  margin: 0 auto;
  display: block;
}
</style>
